import React from "react";
import PropTypes from "prop-types";
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import tw from "twin.macro";
import Layout from "../components/layout";
import { Container as BaseContainer } from "../components/section";
import SEO from "../components/seo";

import "./newsTemplate.css";

const NewsWrapper = tw.div`flex flex-col lg:flex-row container mx-auto`;
const Container = tw(BaseContainer)`w-full lg:w-8/12`;
const PostDate = tw.h2`text-gray-500 mb-4 tracking-wide`;
const BackLink = tw(
  Link
)`text-blue-700 hocus:text-blue-900 transition ease-in-out duration-300`;
const Breadcrumbs = tw.div`text-sm my-4 pb-2 border-b border-gray-100 space-x-2`

const RecentNews = tw.div`w-full lg:w-4/12 lg:ml-8 lg:mt-8 px-6 lg:px-0`;
const RecentNewsHeading = tw.h2`uppercase tracking-wide text-red-900 font-bold border-l-8 border-red-900 pl-2 mb-4`;
const RecentItem = tw(
  Link
)`flex my-4 items-center hover:bg-gray-100 focus:bg-gray-100 transition ease-in-out duration-300`;
const RecentContent = tw.div`flex-1`;
const RecentTitle = tw.h3`font-bold leading-tight`;
const RecentDate = tw.div`text-sm text-gray-700`;
const RecentImg = tw(Img)`rounded w-32 mr-2`;
const NewsHero = tw.div`px-6 h-32 bg-blue-900 flex items-center`;
const NewsHeroText = tw.h1`leading-none text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white font-bold container mx-auto`;

const Template = ({ data }) => {
  const { markdownRemark, allMarkdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  const { edges } = allMarkdownRemark;
  return (
    <Layout>
      <SEO title={frontmatter.title} />
      <NewsHero>
        <NewsHeroText>{frontmatter.title}</NewsHeroText>
      </NewsHero>
      <NewsWrapper>
        <Container>
          <Breadcrumbs>
            <BackLink to="/updates">News</BackLink> <span>&rsaquo;</span> <span>{frontmatter.title}</span>
          </Breadcrumbs>
          <PostDate>{frontmatter.date}</PostDate>
          <div
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </Container>
        <RecentNews>
          <RecentNewsHeading>Recent News</RecentNewsHeading>
          {edges.map((node) => (
            <RecentItem key={node.node.id} to={node.node.frontmatter.slug}>
              {node.node.frontmatter.image && <RecentImg
                fluid={node.node.frontmatter.image.childImageSharp.fluid}
              />}
              <RecentContent>
                <RecentDate>{node.node.frontmatter.date}</RecentDate>
                <RecentTitle>{node.node.frontmatter.title}</RecentTitle>
              </RecentContent>
            </RecentItem>
          ))}
        </RecentNews>
      </NewsWrapper>
    </Layout>
  );
};

Template.propTypes = {
  data: PropTypes.object,
};

export default Template;

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
      }
    }
    allMarkdownRemark(
      limit: 2
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { newsletter: { ne: true } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
            title
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
